import {useEffect} from "react";
import {useHistory} from "react-router-dom";
const usePageLeave = ({condition, callback}) => {
  const history = useHistory();
  const beforeUnloadListener = (event) => {
    if (condition) {
      event.preventDefault();
      return event.returnValue = "Are you sure you want to exit?";
    }
  };
  useEffect(() => {
    window.addEventListener("beforeunload", beforeUnloadListener);
    const unblock = history.block(() => {
      if (condition) {
        return callback(unblock);
      }
      return true;
    });
    return () => {
      window.removeEventListener("beforeunload", beforeUnloadListener);
      unblock();
    };
  }, [condition]);
};
export default usePageLeave;
